import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";

export const axiosInstance = axios.create({
  baseURL: window.location.origin,
  headers: {
    "Content-Type": "application/json",
    "app-version": import.meta.env.VITE_APP_VERSION,
  },
});
axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      window.location.href = `https://auth.masalledesport.com/login?returnUrl=${encodeURIComponent(
        window.location.href
      )}`;
      return Promise.reject(null);
    }
    return Promise.reject(error.response?.data);
  }
);
